import {
  GET_NDA_EMBEDDED_URL_ATTEMPT,
  GET_NDA_EMBEDDED_URL_FAILURE,
  GET_NDA_EMBEDDED_URL_SUCCESS,
  CLEAR_STATE,
} from './actionTypes';

export const initialState = {
  envelop: null,
  attempting: false,
  errorCode: null,
  embeddedUrl: null,
};

export const NdaPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NDA_EMBEDDED_URL_ATTEMPT:
      return {
        ...state,
        embeddedUrl: null,
        attempting: true,
        errorCode: null,
      };
    case GET_NDA_EMBEDDED_URL_FAILURE:
      return {
        ...state,
        embeddedUrl: null,
        errorCode: action.errorCode,
        attempting: false,
      };
    case GET_NDA_EMBEDDED_URL_SUCCESS:
      return {
        ...state,
        embeddedUrl: action.embeddedUrl,
        errorCode: null,
        attempting: false,
      };
    case CLEAR_STATE:
      return {
        initialState,
      };
    default:
      return state;
  }
};
